import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useMemo } from 'react'
import { useIntl } from '@/intl'

import { routesSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import styles from './Headers.module.css'

export function DepartureTitle() {
  const {
    outboundRoute,
  } = usePricesSelector(routesSelector)
  const intl = useIntl()

  const shortDate = useMemo(() => {
    return intl.formatDate(outboundRoute?.departureDate.rawDate, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
  }, [outboundRoute?.departureDate.rawDate])

  return (
    <div className={styles.wrapper}>
      <Typography className={styles.dateTitle} variant="body-l-bold-snug">
        {intl.formatMessage({ id: 'prices_transport_selector_departure_title' })}
      </Typography>
      <Typography className={styles.dateText} variant="body-m-regular-tight">{shortDate}</Typography>
    </div>
  )
}

export function ArrivalTitle() {
  const {
    inboundRoute,
  } = usePricesSelector(routesSelector)
  const intl = useIntl()

  const isDepartureAndArrivalDateDifferent
    = inboundRoute?.arrivalDate?.fullDate
      && inboundRoute?.departureDate?.fullDate !== inboundRoute?.arrivalDate?.fullDate

  const shortDepartureDate = useMemo(() => {
    return intl.formatDate(inboundRoute?.departureDate.rawDate, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
  }, [inboundRoute?.departureDate.rawDate])

  const shortArrivalDate = useMemo(() => {
    return intl.formatDate(inboundRoute?.arrivalDate?.rawDate, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
  }, [inboundRoute?.arrivalDate.rawDate])

  return (
    <div className={styles.wrapper}>
      <Typography className={styles.dateTitle} variant="body-l-bold-snug">
        {intl.formatMessage({ id: 'prices_transport_selector_arrival_title' })}
      </Typography>
      <Typography className={styles.dateText} variant="body-m-regular-tight">
        {shortDepartureDate}
        {isDepartureAndArrivalDateDifferent && ` - ${shortArrivalDate}`}
      </Typography>
    </div>
  )
}
